export interface HighlightSegment {
    text: string;
    match: boolean;
}

const SNIPPET_RADIUS = 30;

function escapeRegex(s: string): string {
    return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// Берём кусок текста вокруг первого совпадения (~60 символов
// в сумме), помечаем границы «…» если обрезали с любого края,
// и режем результат на сегменты {text, match} для рендера —
// match-сегменты получают <mark>-стиль на выходе.
export function buildHighlight(text: string, query: string): HighlightSegment[] {
    if (!text) return [];
    const trimmed = query.trim();
    if (!trimmed) {
        return [{ text, match: false }];
    }

    const lower = text.toLowerCase();
    const needle = trimmed.toLowerCase();
    const firstIdx = lower.indexOf(needle);

    let snippet = text;
    let prefixCut = false;
    let suffixCut = false;

    if (firstIdx >= 0) {
        const start = Math.max(0, firstIdx - SNIPPET_RADIUS);
        const end = Math.min(text.length, firstIdx + needle.length + SNIPPET_RADIUS);
        prefixCut = start > 0;
        suffixCut = end < text.length;
        snippet = text.slice(start, end);
    }

    if (firstIdx < 0) {
        return [{ text: snippet, match: false }];
    }

    const segments: HighlightSegment[] = [];
    if (prefixCut) segments.push({ text: "…", match: false });

    const re = new RegExp(escapeRegex(trimmed), "gi");
    let lastIdx = 0;
    let m: RegExpExecArray | null;
    while ((m = re.exec(snippet)) !== null) {
        if (m.index > lastIdx) {
            segments.push({ text: snippet.slice(lastIdx, m.index), match: false });
        }
        segments.push({ text: m[0], match: true });
        lastIdx = m.index + m[0].length;
        if (m[0].length === 0) re.lastIndex += 1;
    }
    if (lastIdx < snippet.length) {
        segments.push({ text: snippet.slice(lastIdx), match: false });
    }

    if (suffixCut) segments.push({ text: "…", match: false });

    return segments;
}
